function injectStyle (ssrContext) {
  require("!!../../../30/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../30/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0cab6cf3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../30/node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue")
  require("!!../../../30/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../30/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0cab6cf3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../30/node_modules/vue-loader/lib/selector?type=styles&index=1!./Main.vue")
}
var normalizeComponent = require("!../../../30/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../30/node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue"
import __vue_script__ from "!!babel-loader!../../../30/node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue"
/* template */
import __vue_template__ from "!!../../../30/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0cab6cf3\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../30/node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cab6cf3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Main.vue
// module id = null
// module chunks = 